import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getCatalogsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/catalogs`;

const getCatalogByIdUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/catalogs/${dId}`;

const addCatalogUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/catalogs`;

const updateCatalogUrl = (dId, cId, sId) => `/companies/${cId}/subcompanies/${sId}/catalogs/${dId}`;

const toggleCatalogUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/catalogs/${dId}/toggle`;

const formConfigUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/catalogs/form_config`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getCatalogsUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(catalogId, companyId, subcompanyId) {
    const url = getCatalogByIdUrl(catalogId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, catalog) {
    const url = addCatalogUrl(companyId, subcompanyId);

    return this.axios
      .post(url, catalog, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(catalogId, companyId, subcompanyId, catalog) {
    const url = updateCatalogUrl(catalogId, companyId, subcompanyId);

    return this.axios
      .put(url, catalog, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(catalogId, companyId, subcompanyId) {
    const url = toggleCatalogUrl(catalogId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/catalogs.api.js